import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import Slider from '@mui/material/Slider';
import './CropModal.css';
import getCroppedImg from '../utils/cropImage';

const CropModal = ({ imageSrc, onCancel, onCropComplete, aspect = 1, cropShape = 'round', disabled = false }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const onCropCompleteInternal = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleDone = async () => {
    if (disabled) return;
    const croppedBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
    onCropComplete(croppedBlob);
  };

  return (
    <div className="crop-modal-overlay">
      <div className="crop-modal-content">
        <div className="cropper-container">
          <Cropper
            image={imageSrc}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            cropShape={cropShape}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropCompleteInternal}
            showGrid={false}
          />
        </div>

        <div className="crop-controls">
          <Slider
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e, value) => setZoom(value)}
            disabled={disabled}
          />
          <div className="crop-button-row">
            <button onClick={onCancel} className="crop-cancel" disabled={disabled}>Cancel</button>
            <button onClick={handleDone} className="crop-confirm" disabled={disabled}>Done</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropModal;
